export default __webpack_public_path__ + "static/media/hero-idea.0eb1c218.png";